import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import HowToLayout from './HowToLayout';

class HowToEventsMeetups extends Component {
    render() {
        return (
            <HowToLayout title="Events & Meetups">
                <p className="howto-intro">
                    There are two kinds of event on AniMates. <strong className="howto-strong">Featured events</strong> are the real-world ones we curate — conventions, pop-up shops, screenings, tournaments. <strong className="howto-strong">Meetups</strong> are created by members, for members. They work differently, they're worth different amounts of Power Level, and knowing which is which makes the Community tab a lot easier to read.
                </p>

                <section className="howto-section">
                    <h3 className="howto-section-title" style={{fontFamily: "'Chelsea Market', cursive"}}>AniMates Featured Events</h3>
                    <p className="howto-paragraph">
                        Featured events are the big real-world things happening near you — conventions, pop-up shops, screenings, tournaments. They're hosted by AniMates rather than by a member, and they're how you find out what's actually going on in your area.
                    </p>
                    <p className="howto-paragraph">
                        You join one exactly like any other event: open it and tap <strong className="howto-strong">Join Event</strong>, and it lands in your itinerary under <strong className="howto-strong">Attending</strong>.
                    </p>
                </section>

                <section className="howto-section">
                    <h3 className="howto-section-title" style={{fontFamily: "'Chelsea Market', cursive"}}>Checking In with Power Up</h3>
                    <p className="howto-paragraph">
                        At a Featured event nobody is standing there holding a QR code, so check-in works from your location instead. On the day, open the event from your itinerary and tap the <strong className="howto-strong">Power Up</strong> bolt. You'll be asked to allow location access the first time.
                    </p>
                    <p className="howto-paragraph">
                        Three things to know: you have to be <strong className="howto-strong">within 3 miles</strong> of the venue, the bolt only works <strong className="howto-strong">once the event has started</strong>, and you can power up <strong className="howto-strong">once per event</strong>.
                    </p>
                    <p className="howto-paragraph">
                        A Featured check-in is worth <strong className="howto-strong">+5</strong> Power Level, flat — the premium bonus doesn't apply here.
                    </p>
                </section>

                <section className="howto-section">
                    <h3 className="howto-section-title" style={{fontFamily: "'Chelsea Market', cursive"}}>Make It Your Own</h3>
                    <p className="howto-paragraph">
                        This is the part that changes what a Featured event is. On any Featured event you'll find <strong className="howto-strong">Create your own meet up at this event</strong>. Tap it and the create form opens with the venue's location already filled in.
                    </p>
                    <p className="howto-paragraph">
                        From there it's a normal member meetup — your rules, your settings, your invites. So a convention stops being only something you attend and becomes somewhere you organise: your own thing, at the con, on your own terms, for other members to find and join.
                    </p>
                    <p className="howto-paragraph">
                        It's worth full meetup Power Level too — <strong className="howto-strong">+20</strong> for a check-in, <strong className="howto-strong">+30</strong> if you're premium — rather than the Featured <strong className="howto-strong">+5</strong>.
                    </p>
                </section>

                <section className="howto-section">
                    <h3 className="howto-section-title" style={{fontFamily: "'Chelsea Market', cursive"}}>Member Meetups</h3>
                    <p className="howto-paragraph">
                        Meetups are created by members, for members, and they're the heart of AniMates. Anyone can make one — tap the <strong className="howto-strong">+</strong> button in the Community tab, or use <strong className="howto-strong">Create your own meet up at this event</strong> on a Featured event.
                    </p>
                    <p className="howto-paragraph">
                        At a meetup you check in by scanning the host's <strong className="howto-strong">QR code</strong>. The host displays it, you point your camera at it, and you're checked in.
                    </p>
                </section>

                <section className="howto-section">
                    <h3 className="howto-section-title" style={{fontFamily: "'Chelsea Market', cursive"}}>What a Meetup Is Worth</h3>
                    <p className="howto-paragraph">
                        Checking in to a meetup you joined is <strong className="howto-strong">+20</strong>. If you're the host, you earn <strong className="howto-strong">+20</strong> for every attendee who checks in — so a full turnout adds up fast, and hosting is the quickest way to grow your Power Level.
                    </p>
                    <p className="howto-paragraph">
                        Premium members get <strong className="howto-strong">+10</strong> on top of each of those, attending or hosting, so a premium member earns <strong className="howto-strong">+30</strong> per check-in. The full breakdown lives on the <Link to="/how-to-power-level" className="howto-link">Power Level</Link> page.
                    </p>
                </section>

                <section className="howto-section">
                    <h3 className="howto-section-title" style={{fontFamily: "'Chelsea Market', cursive"}}>Hosting: It's Yours to Run</h3>
                    <p className="howto-paragraph">
                        When you host a meetup you decide how it runs. You can invite specific people, add co-hosts to help you, cap the number of attendees, set who's welcome, and restrict it to verified or premium members.
                    </p>
                    <p className="howto-paragraph">
                        Once you're set, <strong className="howto-strong">Lock Event</strong> finalizes the guest list. You can start a group chat so attendees can coordinate, and <strong className="howto-strong">Reveal Meetup Address</strong> shares the exact spot when you're ready — until then the address stays hidden.
                    </p>
                </section>

                <section className="howto-section">
                    <h3 className="howto-section-title" style={{fontFamily: "'Chelsea Market', cursive"}}>Which One Should You Go To?</h3>
                    <p className="howto-paragraph">
                        Both. Featured events are how you find the real things happening near you. Meetups are how you make something your own.
                    </p>
                    <p className="howto-paragraph">
                        Meetups are worth more Power Level on purpose — a member organising something is what this app is for.
                    </p>
                </section>

                <p className="howto-footer-note">
                    Still need a hand? Email <a href="mailto:hello@animates.app" className="howto-link">hello@animates.app</a>.
                </p>
            </HowToLayout>
        );
    }
}

export default HowToEventsMeetups;
